import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://progere.ca";

export function SEO({ title, description, path = "", image = "/og-image.png" }) {
  const fullTitle = title
    ? `${title} — PROGÈRE`
    : "PROGÈRE — L'écosystème de gestion pour la construction";
  const url = `${SITE}${path}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
